import { graphql } from "@/lib/gql/__generated__";

export const RoomPriceRankDailyStatus_RoomPriceRankPage_Query = graphql(`
	query RoomPriceRankDailyStatus_RoomPriceRankPage($hotelID: ID!, $startDt: String!, $endDt: String!) {
		roomPriceRankDailyStatus(hotelID: $hotelID, startDt: $startDt, endDt: $endDt) {
			id
			hotelID
			statuses {
				hotelID
				date
				priceRankID
				color
			}
		}
	}
`);
